module.exports = __webpack_public_path__ + "static/media/image-gallery-2.f2a3735b.jpg";